<template>
  <!-- Footer -->
  <footer class="footer bg-light">
    <div class="container">
      <div class="row">
        <div class="col-lg-6 h-100 text-center text-lg-left">
          <ul class="list-inline mb-2">
            <!-- <li class="list-inline-item">
              <router-link :to="{name: 'home'}">Home</router-link>
            </li> -->
            <!-- <li class="list-inline-item">&sdot;</li> -->
            <li class="list-inline-item">
              <router-link :to="{name: 'privacypolicy'}">プライバシーポリシー</router-link>
            </li>
            <li class="list-inline-item">&sdot;</li>
            <li class="list-inline-item">
              <router-link :to="{name: 'asct'}">特定商取引法に基づく表記</router-link>
            </li>
            <li class="list-inline-item">&sdot;</li>
            <li class="list-inline-item">
              <router-link :to="{name: 'termsofservice'}">利用規約</router-link>
            </li>
            <!-- <li class="list-inline-item">&sdot;</li>
            <li class="list-inline-item">
              <a href="https://status.proofrog.cloud" target="_blank" class="target-blank">ステータス</a>
            </li> -->
            <li class="list-inline-item">&sdot;</li>
            <li class="list-inline-item">
              <a href="http://help.poodl.cloud/support/home" target="_blank" class="target-blank">ヘルプ</a>
            </li>
            <li class="list-inline-item">&sdot;</li>
            <li class="list-inline-item">
              <router-link :to="{ name: 'contact' }"><el-button class="button-simple" type="text">お問い合わせ</el-button></router-link>
            </li>
            <li class="list-inline-item">&sdot;</li>
            <li class="list-inline-item">
              <router-link :to="{name: 'about'}">開発元</router-link>
            </li>
          </ul>
          <p class="text-muted small mb-4 mb-lg-0">&copy; Taktpixel Co., Ltd. 2019. All Rights Reserved.</p>
        </div>
        <!-- <div class="col-lg-6 h-100 text-center text-lg-right my-auto">
          <ul class="list-inline mb-0">
            <li class="list-inline-item mr-3">
              <a href="#">
                <i class="fab fa-facebook fa-2x fa-fw"></i>
              </a>
            </li>
            <li class="list-inline-item mr-3">
              <a href="#">
                <i class="fab fa-twitter-square fa-2x fa-fw"></i>
              </a>
            </li>
            <li class="list-inline-item">
              <a href="#">
                <i class="fab fa-instagram fa-2x fa-fw"></i>
              </a>
            </li>
          </ul>
        </div> -->
        <div class="col-lg-6 h-100 text-center text-lg-right my-auto twitter-widget">
          <timeline
            :id="twitterId"
            :source-type="'profile'"
            :options="{ 'height': twitterHeight }" />
        </div>
      </div>
    </div>
  </footer>

</template>

<script>
import { Timeline } from 'vue-tweet-embed';

export default {
  name: 'Footer',
  components: {
    Timeline,
  },
  data() {
    return {
      twitterId: 'taktpixel',
      twitterHeight: '380',
    }
  },
  props: {
  },
  methods: {
    handleContact() {
      if (this.$intercom) {
        this.$intercom.show();
        return;
      }
      window.open('https://taktpixel.co.jp', '_blank');
    }
  }
}
</script>

<style scoped lang="scss">
.button-simple {
  font-size: 1rem;
  background: transparent;
  font-weight: normal;

}
.twitter-widget {
  width: 100%;
}
</style>
